<template>
  <ConversionDetail
    :s-transaction-id="$route.params.idConversion"
    @back="$router.go(-1)"
  />
</template>

<script>
import ConversionDetail from "./ConversionDetail.vue";

export default {
  name: "ConversionView",
  components: {
    ConversionDetail,
  },
};
</script>
